import React, { Component, PropTypes } from 'react';
import Translate from 'react-translate-component';

class LoginBottomElement extends Component {
  static propTypes = {
    isLogin: PropTypes.bool,
    isBankID: PropTypes.bool,
    handleClick: PropTypes.func
  }

  renderTitleText () {
    if (this.props.isBankID) {
      return (<span>
        <Translate
          content='NO_BANK_ID' />
          &nbsp;
      </span>);
    }
    return null;
  }

  renderText () {
    if (this.props.isLogin) {
      return (<div className='login-row-child justify-center'>
        {this.renderTitleText()}
        <Translate
          id={this.props.isBankID ? 'EMAIL' : 'BANKID'}
          className='active-link-text'
          content={this.props.isBankID ? 'LOG_IN_WITH_EMAIL_LINK' : 'LOG_IN_WITH_BANKID_LINK'}
          onClick={this.props.handleClick}
        />
      </div>);
    }

    return (<div
      className='login-row-child justify-center'
      onClick={this.props.handleClick}
    >
      {this.renderTitleText()}
      <Translate
        id={this.props.isBankID ? 'EMAIL' : 'BANKID'}
        className='active-link-text'
        content={this.props.isBankID ? 'CREATE_ACCOUNT_WITHOUT_BANKID' : 'CREATE_ACCOUNT_WITH_BANKID'}
        onClick={this.props.handleClick}
      />
    </div>);
  }

  render () {
    return (
      <div className='login-row-container margin'>
        {this.renderText()}
      </div>
    );
  }
}

export default LoginBottomElement;



/** WEBPACK FOOTER **
 ** ./src/views/login-view/tabs/login-bottom-element.js
 **/